var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.components.open,{tag:"component",attrs:{"domTriggersSelector":_vm.config.open.triggersSelector,"domTriggerEvent":_vm.config.open.triggerEvent,"delegateEvent":_vm.config.open.delegateEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }